module.exports = __webpack_public_path__ + "static/img/banner-m1.416fa052.jpg";